import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "item" }
const _hoisted_2 = { class: "label" }

import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";


export default /*@__PURE__*/_defineComponent({
  __name: 'AccountLogout',
  props: {
    returnUrl: {}
  },
  setup(__props: any) {

const props = __props;

const localizer = Localizer;

const routes = (window as any).App.routes;

async function logout() {
	localStorage.removeItem("token");
	await Axios.post(routes.Account_User_Logout, null, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } });
	window.location.href = props.returnUrl ? props.returnUrl : "/";
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (logout())),
      class: "button"
    }, [
      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "icon fastic-logout" }, null, -1)),
      _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(localizer).get("Account.Common.Logout")), 1)
    ])
  ]))
}
}

})